var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class DatesGateway {
    constructor(connections, queryFactory, mapper, clock, timeRange) {
        this.connections = connections;
        this.queryFactory = queryFactory;
        this.mapper = mapper;
        this.clock = clock;
        this.timeRange = timeRange;
        this.connection = this.connections.filterSportsGroupedByDate();
    }
    GetDates(timezone, sportId) {
        return __awaiter(this, void 0, void 0, function* () {
            const targetDay = this.clock.getBeginningOfTodayForTimeZone(timezone);
            const request = this.queryFactory(targetDay.toISOString(), this.timeRange, sportId.toString());
            const response = yield new Promise((resolve, reject) => {
                this.connection.loadData(request, resolve, reject);
            }).then((x) => {
                this.connection.deactivate();
                return x;
            });
            this.mapper.setToday(targetDay);
            return this.mapper.getDates(response, timezone);
        });
    }
    deactivate() {
        this.connection.deactivate();
    }
}
//# sourceMappingURL=DatesGateway.js.map